import { useTheme } from "@mui/material";
import React from "react";
import LightLogo from "assets/logo.svg";
import DarkLogo from "assets/logo_dark.svg";

function Logo({ width }) {
  const theme = useTheme();
  const getLogo = () => (theme.palette.mode === "dark" ? DarkLogo : LightLogo);
  return <img src={getLogo()} alt="" style={{ width: width }} />;
}

export default Logo;
